// select-size.js - Fixed: also checks hidden select[name="id"] as fallback when radios unchecked
document.addEventListener('DOMContentLoaded', function() {
  var productForms = document.querySelectorAll('form[action="/cart/add"], form[action*="/cart/add"]');
  productForms.forEach(function(form) {
    form.addEventListener('submit', function(event) {
      if (!form.offsetParent) return; // skip hidden forms (quick-add modal shells)
      var submitter = event.submitter || document.activeElement;
      if (submitter && submitter.classList && submitter.classList.contains('variant-button')) return;

      var sizeOptions = Array.from(document.querySelectorAll('input[type="radio"][name="Size"], input[type="radio"][name="size"]'));
      if (sizeOptions.length === 0) return;

      var visibleSizeOptions = sizeOptions.filter(function(input) { return input.offsetParent !== null; });
      var optionsToCheck = visibleSizeOptions.length > 0 ? visibleSizeOptions : sizeOptions;
      var sizeSelected = optionsToCheck.some(function(input) { return input.checked; });

      // Fallback: if no radio is checked, check if the hidden select has a valid variant selected
      // This handles themes where visual swatches update the hidden select without checking the radio
      if (!sizeSelected) {
        var hiddenSelect = form.querySelector('select[name="id"]');
        if (hiddenSelect && hiddenSelect.value && hiddenSelect.value !== '') {
          sizeSelected = true;
        }
      }

      if (sizeSelected) {
        var existingError = document.getElementById('select-size-error');
        if (existingError) existingError.textContent = '';
      } else {
        event.preventDefault();
        event.stopImmediatePropagation();
        var errorEl = document.getElementById('select-size-error');
        if (!errorEl) {
          errorEl = document.createElement('p');
          errorEl.id = 'select-size-error';
          errorEl.style.cssText = 'color:#e74c3c;font-size:13px;margin:8px 0;font-weight:500;';
          var atcBtn = form.querySelector('.add-to-cart:not(.variant-button)');
          if (atcBtn && atcBtn.parentNode) {
            atcBtn.parentNode.insertBefore(errorEl, atcBtn);
          } else {
            var sizeWrapper = document.querySelector('.variant-input-wrap, .selector-wrapper');
            if (sizeWrapper && sizeWrapper.parentNode) sizeWrapper.parentNode.insertBefore(errorEl, sizeWrapper.nextSibling);
          }
        }
        errorEl.textContent = 'Please select a size before adding to cart';
        clearTimeout(errorEl._hideTimeout);
        errorEl._hideTimeout = setTimeout(function() { errorEl.textContent = ''; }, 3000);
      }
    }, true);
  });
});